import ThisModule from "./ButtonCopyToClipboard";

export default ThisModule;
